import React, { lazy, Suspense, useEffect } from "react";

import './App.css';
import './Webstyle.css'
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "./Home.js";
import WebHome from "./web-development/WebHome.js";
import NavbarMain from "./components/navbar/NavbarMain.js";
import Footer from "./components/footer/index.js";
import AppHome from "./app-development/AppHome.js";
import HireDeveloperHome from "./developer-hire/HireDeveloperHome.js";
import AboutUs from "./developer-hire/AboutUs.js";
import ContactUs from "./developer-hire/ContactUs.js";
import SeoHome from "./components/search-engine/SeoHome.js";
import Healthcare from "./Pages/HealthCare.js";
import Faq from "./developer-hire/Faq.js";
import SocialMediaHome from "./developer-hire/SocialMediaHome.js";
import PrivacyPolicy from "./developer-hire/PrivacyPolicy.js";
import Portfolio from "./developer-hire/Portfolio.js";
import Blog from "./developer-hire/Blog.js";
import PayperClick from "./developer-hire/PayperClick.js";
import Education from "./Pages/Education.js";
import Retail from "./Pages/Retail.js";
import Logistics from "./Pages/Logistics.js";
import Petrochemical from "./Pages/Petrochemical.js";
import Multimedia from "./Pages/MusicandVideo.js";
import OurWork from "./Pages/OurWork.js";

function App() {
const location = useLocation();
const { pathname, state } = location;  

useEffect(() => {
  window.scrollTo(0, 0);
}, [pathname])

  return (
    <>
     <NavbarMain />
      <Routes>
       
        {/* <Route path="/web-development" element={<WebHome/>} />
        <Route path="/app-development" element={<AppHome/>} />
        <Route path="/hire-dedicated-developers" element={<HireDeveloperHome/>} />
        <Route path="/about-us" element={<AboutUs/>} />
        <Route path="//contact-us" element={<ContactUs/>} /> */}
        {/* <Route path="/search-engine-ptimization" element={<SeoHome/>} /> */}
        {/* <Route path="/healthcare" element={<Healthcare/>} />
        <Route path="/faq" element={<Faq/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/portfolio" element={<Portfolio/>} />
        <Route path="/blog" element={<Blog/>} />
        <Route path="/pay-per-click-management" element={<PayperClick/>} />
        <Route path="/social-media-marketing" element={<SocialMediaHome/>} />
        <Route path="/education" element={<Education/>} />
        <Route path="/retail" element={<Retail/>} />
        <Route path="/logistics" element={<Logistics/>} />
        <Route path="/oilgas" element={<Petrochemical/>} />
        <Route path="/musicvideo" element={<Multimedia/>} />
        <Route path="/our-work" element={<OurWork/>} /> */}
        <Route path="/" element={<Home/>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;